// extracted by mini-css-extract-plugin
export default {"dlEventAnnotationType":"src-js-containers-encounter-components-EventAnnotationType---dlEventAnnotationType---Q1NbU"};